import {
  AssetEncumbrance,
  AssetPropertyRightKind,
  PendingDocumentMove,
  PropertyRightAnswers,
} from "../../../api/ClientFileApi";

export const PropertyRightsMaxLength = {
  tenantOrOwner: 255,
  landlord: 255,
  text: 4000,
} as const;

export interface PropertyRightFormValue {
  key: string;
  id: string | null;
  kind: AssetPropertyRightKind;
  landlord: string | null;
  isCurrentHome: boolean | null;
  propertyDetails: string | null;
  expectsProceeds: boolean | null;
  proceedsEncumbrance: AssetEncumbrance | null;
  encumberedClaimId: string | null;
  encumberedCreditorName: string | null;
  isProceedsAmountKnown: boolean | null;
  proceedsAmount: number | null;
  proceedsDate: Date | null;
  remarks: string | null;
  details: string | null;
}

export type PropertyRightField = Exclude<
  keyof PropertyRightFormValue,
  "key" | "id" | "kind" | "encumberedCreditorName"
>;

export type PropertyRightAnswerField = keyof PropertyRightAnswers;

export interface PropertyRightDocumentFiles {
  tenancyRightDocuments: File[];
  companyShareDocuments: File[];
  cooperativeMembershipDocuments: File[];
  otherPropertyRightDocuments: File[];
}

export type PropertyRightDocumentField = keyof PropertyRightDocumentFiles;

export interface PropertyRightsFormValues extends PropertyRightDocumentFiles {
  answers: PropertyRightAnswers;
  propertyRights: PropertyRightFormValue[];
  documentMoves: PendingDocumentMove[];
}
